export default () => {
	let $addLateral = $(".Games-addLateral");
	if ($addLateral.length === 0) {
		return;
	}
	$(window).scroll(() => {
		const $listaPrincipal =			window.section === "homepage"
				? window.$(".Games-lista-container")
				: $(".Games-lista--principal");
		$addLateral = $(".Games-addLateral");
		if (!$listaPrincipal) {
			return;
		}
		const distanciaBorde = $listaPrincipal[0].getBoundingClientRect();
		const distanciaInicioContenedor = $(".Games").offset().top;
		const paginado = $(".Games-pagination").length > 0;
		// Caso Default, No hay que desplazar el scroll, simplemente lo dejamos pegado arriba (los 10px son por el padding)
		const lastTop = $addLateral.css("top");
		let top = $listaPrincipal.offset().top - distanciaInicioContenedor + 10;
		const enPiso =			distanciaBorde.top + distanciaBorde.height <= $addLateral.height();

		// Tenemos que desplazar el banner con nosotros
		if (distanciaBorde.top < 0 && !enPiso) {
			top = window.pageYOffset - distanciaInicioContenedor;
		}
		// En el Piso, debemos dejarlo lo mas abajo posible sin salirse
		if (enPiso) {
			top = lastTop;
		}
		$addLateral.css("top", top);
	});
	if (window.section !== "homepage") {
		$(window).scroll();
	}
	
};
